(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function init(root) {
    if (!root || root.dataset.tsInit === '1') return;
    root.dataset.tsInit = '1';

    const viewport = root.querySelector('[data-ts-viewport]');
    const track = root.querySelector('[data-ts-track]');
    const pager = root.querySelector('[data-ts-pager]');
    const slides = track ? Array.from(track.querySelectorAll('[data-ts-slide]')) : [];

    if (!viewport || !track || !pager || !slides.length) return;

    let step = 0;           // distance between slides (including gap)
    let positions = 1;      // how many "pages"
    let activeIndex = 0;    // current page (0-based)
    let dots = [];

    /* ---------- LAYOUT HELPERS ---------- */

    function computeStep() {
      if (slides.length < 2) return 0;
      // distance from left of slide[0] to slide[1]
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function getPerView() {
      if (!step) return 1;
      const w = viewport.clientWidth;
      // how many steps fit into the viewport width
      const approx = Math.round(w / step);
      return clamp(approx, 1, 3); // at most 3 cards per view
    }

    function computePositions() {
      if (!step) step = computeStep();
      if (!step) return 1;
      const perView = getPerView();
      const raw = slides.length - perView;
      return Math.max(1, raw + 1); // number of valid starting indices
    }

    function setActiveDot(index) {
      dots.forEach((btn, i) => {
        btn.classList.toggle('is-active', i === index);
      });
    }

    function goTo(index) {
      if (!step) step = computeStep();
      positions = computePositions();
      const maxIdx = positions - 1;
      activeIndex = clamp(index, 0, maxIdx);
      const x = step * activeIndex;
      track.style.transform = `translate3d(-${x}px,0,0)`;
      setActiveDot(activeIndex);
    }

    function buildDots() {
      step = computeStep();
      positions = computePositions();

      pager.innerHTML = '';
      dots = [];

      for (let i = 0; i < positions; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'w-2.5 h-2.5 rounded-full transition-all duration-300 bg-[rgba(71,70,73,0.22)]';
        if (i === 0) btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.addEventListener('click', () => {
          goTo(i);
        });
        pager.appendChild(btn);
        dots.push(btn);
      }
    }

    function refresh() {
      // disable transition while recalculating so it doesn't animate on resize
      const prevTransition = track.style.transition;
      track.style.transition = 'none';

      step = computeStep();
      positions = computePositions();
      if (activeIndex >= positions) activeIndex = positions - 1;
      if (activeIndex < 0) activeIndex = 0;

      buildDots();
      goTo(activeIndex);

      // re-enable transition
      void track.offsetWidth;
      track.style.transition = prevTransition || 'transform 420ms cubic-bezier(0.22, 0.61, 0.36, 1)';
    }

    /* ---------- SWIPE (POINTER) SUPPORT ---------- */

    let isPointerDown = false;
    let startX = 0;
    const SWIPE_THRESHOLD = 40; // px

    function onPointerDown(e) {
      isPointerDown = true;
      startX = e.clientX;
    }

    function onPointerUp(e) {
      if (!isPointerDown) return;
      isPointerDown = false;

      const dx = e.clientX - startX;
      if (Math.abs(dx) < SWIPE_THRESHOLD) return;

      if (dx < 0) {
        // swipe left -> next
        goTo(activeIndex + 1);
      } else {
        // swipe right -> prev
        goTo(activeIndex - 1);
      }
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', () => { isPointerDown = false; });
    viewport.addEventListener('pointerleave', () => { isPointerDown = false; });

    /* ---------- INIT ---------- */

    refresh();
    window.addEventListener('resize', refresh);
  }

  function initAll() {
    document.querySelectorAll('[data-ts-carousel]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();